import { renderShape, makeAngle, moveCircleMesh, setOpacity, moveEllipseMesh, materialDefault, rotateMesh, genderateRandomRadius, easeInOut } from "./util";
import { PlanetProps, Shape, RingProps, SatelliteProps } from "./../Data/planet";
import * as THREE from "three";
import theme from "Styles/theme";

// FIELD
const ANGLE_X = -Math.PI / 2.6;
const RADIUS_INIT = 200;
const RADIUS_GAP = 60;

export const renderPlanet = (scene: any, data: PlanetProps, index: number) => {
	// const radius = data.orbitRadius;
	const orbitRadius = genderateRandomRadius(RADIUS_INIT, RADIUS_GAP, index);

	// GROUP-ORBIT
	var pivot = new THREE.Group();
	scene.add(pivot);

	// ORBIT
	var orbit_geo = new THREE.TorusBufferGeometry(orbitRadius, 0.5, 16, 100);
	var orbit_mat = new THREE.MeshBasicMaterial({
		color: theme.color.three.white,
		transparent: true,
		opacity: 0.05
	});
	var orbit = new THREE.Mesh(orbit_geo, orbit_mat);
	pivot.rotation.x = ANGLE_X;
	pivot.add(orbit);

	// POSITION_PLANET
	const planet_pos_geo = renderShape(Shape.SPHERE, theme.size.three.planet_pos);
	const planet_pos_mat = new THREE.MeshBasicMaterial({
		color: theme.color.three.default,
		transparent: true,
		opacity: 0,
		visible: false
	});
	const planet_pos = new THREE.Mesh(planet_pos_geo, planet_pos_mat);
	planet_pos.name = data.id;
	scene.add(planet_pos);

	// PLANET_DOT
	const planet_dot_geo = renderShape(data.shape, theme.size.three.planet_dot);
	// const planet_dot_mat = new THREE.MeshBasicMaterial({
	// 	color: theme.color.three.default,
	// 	// transparent: true,
	// 	opacity: 1
	// });
	const planet_dot_mat = materialDefault({
		color: theme.color.three.default
	});
	const planet_dot = new THREE.Mesh(planet_dot_geo, planet_dot_mat);
	planet_dot.name = data.id;
	scene.add(planet_dot);

	// GROUP_PLANET
	const group_planet = new THREE.Group();
	group_planet.name = data.id;
	scene.add(group_planet);

	// --zPlanet / planet
	const planet_geo = renderShape(data.shape, theme.size.three.planet_radius);
	const planet_mat = materialDefault({ color: theme.color.three[data.color] });
	const planet = new THREE.Mesh(planet_geo, planet_mat);
	group_planet.add(planet);
	pivot.add(group_planet);

	group_planet.position.x = orbitRadius;
	planet_pos.position.x = orbitRadius;

	// --zPlanet / sub
	let ringMesh;
	if (data.ring) {
		ringMesh = renderRing(data.ring, group_planet, theme.size.three.planet_radius);
	}

	let satelliteMesh;
	if (data.satellite) {
		satelliteMesh = renderSatellite(data.satellite, group_planet, theme.size.three.planet_radius);
	}

	// setOpacity(group_planet, 0);
	group_planet.scale.set(0, 0, 0);

	return {
		...data,
		orbitRadius,
		planet,
		speed: Math.random() * 0.001,
		pos_rand: Math.random() * Math.PI * 2,
		group_planet,
		ring: { ...data.ring, mesh: ringMesh },
		satellite: { ...data.satellite, mesh: satelliteMesh },
		planet_pos,
		planet_dot
	};
};

export const renderPlanetArr = (scene: any, data: PlanetProps[]) => {
	const renderedPlanet = data.map((el, index) => {
		return renderPlanet(scene, el, index);
	});
	return renderedPlanet;
};

export const renderRing = (ring: RingProps, group: any, planetRadius: number) => {
	// DRAW ring
	const ring_geo = new THREE.RingBufferGeometry(planetRadius + ring.radius, planetRadius + ring.radius + ring.thikness, 64);
	const material = materialDefault({ color: ring.color });

	var mesh = new THREE.Mesh(ring_geo, material);
	mesh.rotation.y = 0;
	mesh.rotation.y = makeAngle(ring.angle);
	group.add(mesh);
	return mesh;
};

export const renderSatellite = (satellite: SatelliteProps, group: any, planetRadius: number) => {
	// --zPlanet / satellite
	const satellite_mat = materialDefault();
	const satellite_geo = renderShape(satellite.shape, planetRadius * satellite.radiusRatio);
	const satellite_mesh = new THREE.Mesh(satellite_geo, satellite_mat);
	satellite_mesh.position.x = planetRadius + satellite.orbitRadius;
	group.add(satellite_mesh);
	return satellite_mesh;
};

export const planetAnimation = (palnet_arr: any, framecount: number, nowId: string, hoverId: string, nowFrame: number) => {
	palnet_arr.forEach((el: any) => {
		const { group_planet, planet_pos, planet_dot, orbitRadius } = el;

		moveCircleMesh(group_planet, orbitRadius, framecount, el.speed, el.pos_rand);
		moveEllipseMesh(planet_pos, orbitRadius, ANGLE_X, framecount, el.speed, el.pos_rand, true);
		moveEllipseMesh(planet_dot, orbitRadius, ANGLE_X, framecount, el.speed, el.pos_rand, true);
		rotateMesh(el.planet);
		rotateMesh(planet_dot);

		if (el.ring.mesh !== undefined) {
			ringAnimation(el.ring, framecount);
		}
		if (el.satellite.mesh !== undefined) {
			satelliteAnimation(el.satellite, framecount, theme.size.three.planet_radius);
		}

		// PLANET ANIMATION
		mouseAnimation(nowFrame, hoverId, nowId, group_planet, planet_dot);
	});
};

const mouseAnimation = (frameCount: number, hoverId: string, nowId: string, planet: any, planet_dot: any) => {
	if (planet.name === hoverId || planet.name === nowId) {
		// HOVER OR FOCUS
		if (planet.scale.x >= 1) return;
		const planet_scale_nowValue = planet.scale.x;
		const planet_scale_target = 1;
		let planet_scale_newValue = easeInOut(frameCount, planet_scale_nowValue, planet_scale_target - planet_scale_nowValue, 40);

		planet_scale_newValue = +planet_scale_newValue.toFixed(2);
		if (planet_scale_newValue <= 0) {
			planet_scale_newValue = 0;
		} else if (planet_scale_newValue >= 1) {
			planet_scale_newValue = 1;
		}

		planet.scale.set(planet_scale_newValue, planet_scale_newValue, planet_scale_newValue);
		setOpacity(planet, planet_scale_newValue);
		planet_dot.scale.set(1 - planet_scale_newValue, 1 - planet_scale_newValue, 1 - planet_scale_newValue);
	} else {
		// OUT
		if (planet.scale.x === 0) return;
		if (planet.scale.x < 0) {
			planet.scale.x = 0;
			return;
		}

		const planet_scale_nowValue = planet.scale.x;
		const planet_scale_target = 0;
		let planet_scale_newValue = easeInOut(frameCount, planet_scale_nowValue, planet_scale_target - planet_scale_nowValue, 40);
		planet_scale_newValue = +planet_scale_newValue.toFixed(2);

		planet.scale.set(planet_scale_newValue, planet_scale_newValue, planet_scale_newValue);
		setOpacity(planet, planet_scale_newValue);
		planet_dot.scale.set(1 - planet_scale_newValue, 1 - planet_scale_newValue, 1 - planet_scale_newValue);
	}
};

export const ringAnimation = (ring: any, frameCount: number, value: number = -0.005) => {
	rotateMesh(ring.mesh, value);
	// ring.mesh.rotation.x += 0.005;
	// ring.mesh.rotation.y += 0.005;
};

export const satelliteAnimation = (satellite: any | undefined, frameCount: number, planetRadius: number) => {
	if (satellite) {
		rotateMesh(satellite.mesh);
		moveCircleMesh(satellite.mesh, planetRadius + satellite.orbitRadius, frameCount);
	}
};
